import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { Translation } from 'react-i18next';
import XLRLogger from '../common/helpers/logger';

interface ErrorState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<{}, ErrorState> {
  public constructor(props: React.PropsWithChildren<unknown>) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(error: unknown): ErrorState {
    XLRLogger.info({
      source: 'Error Boundary',
      message: `getDerivedStateFromError called, error was ${error}`,
    });
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    XLRLogger.error({ source: errorInfo.componentStack, message: error.message });
  }

  public render(): React.ReactNode {
    if (this.state.hasError) {
      // TODO: Add UI for unhandled application error. This will be in the UI Redesign epic.
      return (
        <Grid container justifyContent={'center'} alignItems={'center'} style={{ height: '100%' }}>
          <Typography variant='h2' style={{ textAlign: 'center' }}>
            <Translation>{t => t('CriticalError')}</Translation>
          </Typography>
        </Grid>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
